module.exports = __webpack_public_path__ + "static/09-d75b7bef3adb7a878c0447de63960744.jpg";